<div class="wrapper">
  <div class="gradient-bar"></div>
  <mat-card>
    <img
      src="../../../assets/images/actabl-blue.png"
      alt="Actabl"
      class="actabl"
    />
    <mat-card-content>
      <a class="return-link" [routerLink]="'/' + returnPage">
        <mat-icon>keyboard_backspace</mat-icon>
        {{
          'forgotPassword.back'
            | translate: { page: 'forgotPassword.' + returnPage | translate }
        }}</a
      >
      <mat-divider></mat-divider>
      @if (isSuccess) {
      <div>
        <h6>
          {{ 'forgotPassword.success.title' | translate }}
        </h6>
        <p>
          {{ 'forgotPassword.success.text' | translate }}
        </p>
      </div>
      } @else {
      <div>
        @if (hasError) {
        <div class="alert alert-danger" role="alert">
          <div class="alert-message">
            <mat-icon>error</mat-icon>
            {{ 'tokenExpiration.expiredResetToken' | translate }}
          </div>
          <button mat-icon-button aria-label="close" (click)="hideAlert()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        }
        <h6>
          {{ 'forgotPassword.title' | translate }}
        </h6>
        <p>
          {{
            'forgotPassword.text'
              | translate
                : {
                    actabl: 'Actabl'
                  }
          }}
        </p>
        <p>
          {{ 'forgotPassword.continuation' | translate: ActablProductNames }}
        </p>
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label> {{ 'pairing.username' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                autocomplete="username"
                id="username"
                name="username"
                [(ngModel)]="username"
                type="text"
                required
              />
            </mat-form-field>
          </div>
          <button
            class="submit-button"
            color="primary"
            type="submit"
            mat-flat-button
            [disabled]="!username"
          >
            {{ 'forgotPassword.submit' | translate }}
          </button>
        </form>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
